var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"static-map-container"},[_c('img',{staticClass:"static-map-scale-1",attrs:{"height":_vm.height,"width":_vm.width,"src":(_vm.url + "&scale=1"),"alt":""}}),_vm._v(" "),_c('img',{staticClass:"static-map-scale-2",attrs:{"height":_vm.height,"width":_vm.width,"src":(_vm.url + "&scale=2"),"alt":""}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79d51cb6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/components/apps/static-map.vue
// module id = yWFn
// module chunks = 0